/**
 * PDP Save to Wishlist — free OCWishlist toggle + dark state.
 */
(() => {
  function selectedVariantId(root) {
    const fromData = root?.dataset.variantId;
    const form =
      document.querySelector('product-form-component form') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form form');
    const input = form?.querySelector('[name="id"]');
    return String(input?.value || fromData || '');
  }

  function entryFrom(root) {
    return {
      productId: root.dataset.productId,
      handle: root.dataset.productHandle,
      title: root.dataset.productTitle,
      url: root.dataset.productUrl,
      image: root.dataset.productImage,
      price: root.dataset.productPrice,
      variantId: selectedVariantId(root),
    };
  }

  function sync(root) {
    if (!window.OCWishlist || !root.dataset.productId) return;
    const variantId = selectedVariantId(root);
    const active = window.OCWishlist.has(root.dataset.productId, variantId);
    const btn = root.querySelector('[data-wishlist-trigger]');
    const labelEl = root.querySelector('[data-wishlist-label]');
    const label = active
      ? root.dataset.labelAdded || 'Added to Wishlist'
      : root.dataset.label || 'Save to Wishlist';

    root.classList.toggle('is-wishlisted', active);
    if (btn) {
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', label);
    }
    if (labelEl) labelEl.textContent = label;
  }

  function bind(root) {
    if (root.dataset.wishlistBound === 'true') return;
    root.dataset.wishlistBound = 'true';

    const btn = root.querySelector('[data-wishlist-trigger]');
    btn?.addEventListener('click', (event) => {
      event.preventDefault();
      if (!window.OCWishlist) return;
      const result = window.OCWishlist.toggle(entryFrom(root));
      sync(root);
      // Optional: light feedback via aria
      if (result.added) btn.setAttribute('data-just-added', 'true');
    });

    // Variant changes update selected id in the product form
    document.addEventListener('change', (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('variant-picker, product-form-component, form[action*="/cart/add"]')) {
        sync(root);
      }
    });

    document.addEventListener(window.OCWishlist.CHANGE, () => sync(root));
    sync(root);
  }

  function init() {
    if (!window.OCWishlist) return;
    document.querySelectorAll('[data-wishlist-block]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
